import { Notice } from "./ui";

/*
 * Where a record lives, in its window: a notice while it's only in this app (removing it from
 * ServiceM8, or adding it back, is in its More menu: recordActions.tsx syncAction).
 * `kind` names it in the messages ("item", "supplier").
 */

/** While a record is only here: where it is, why, and a warning if its ServiceM8 copy was restored there. */
export function SyncNotice(props: Readonly<{ kind: string; synced: boolean; restoredInServiceM8: boolean; unavailable?: string | null }>) {
    if (props.synced) return null;
    if (props.restoredInServiceM8) {
        return (
            <Notice tone="warning">
                Someone restored this {props.kind} in ServiceM8. The copy here is still the one used: Add to ServiceM8 to send these values there.
            </Notice>
        );
    }
    return <Notice>{props.unavailable ?? `Only in this app: it's archived in ServiceM8. Changes are saved here until it's added to ServiceM8 again.`}</Notice>;
}
